export const IotTargetIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M15.1895 11.1328C15.1895 13.4757 13.2902 15.375 10.9473 15.375C8.60437 15.375 6.70508 13.4757 6.70508 11.1328C6.70508 8.78992 8.60437 6.89062 10.9473 6.89062C13.2902 6.89062 15.1895 8.78992 15.1895 11.1328ZM8.30776 11.1328C8.30776 12.5906 9.48951 13.7723 10.9473 13.7723C12.405 13.7723 13.5868 12.5906 13.5868 11.1328C13.5868 9.67505 12.405 8.49331 10.9473 8.49331C9.48951 8.49331 8.30776 9.67505 8.30776 11.1328Z"
        fill="white"
      />
      <path
        d="M19.4473 11.1328C19.4473 15.8272 15.6417 19.6328 10.9473 19.6328C6.25285 19.6328 2.44727 15.8272 2.44727 11.1328C2.44727 6.43839 6.25285 2.63281 10.9473 2.63281C15.6417 2.63281 19.4473 6.43839 19.4473 11.1328ZM4.1232 11.1328C4.1232 14.9016 7.17844 17.9569 10.9473 17.9569C14.7161 17.9569 17.7713 14.9016 17.7713 11.1328C17.7713 7.36398 14.7161 4.30874 10.9473 4.30874C7.17844 4.30874 4.1232 7.36398 4.1232 11.1328Z"
        fill="white"
      />
      <path
        d="M20.8139 10.0937C21.3109 10.0937 21.7139 10.4967 21.7139 10.9937C21.7139 11.4908 21.3109 11.8937 20.8139 11.8937L18.8458 11.8937L18.8458 10.0937L20.8139 10.0937Z"
        fill="white"
      />
      <path
        d="M10.0996 1.18125C10.0996 0.684194 10.5026 0.28125 10.9996 0.28125C11.4967 0.28125 11.8996 0.684194 11.8996 1.18125L11.8996 3.1493L10.0996 3.1493L10.0996 1.18125Z"
        fill="white"
      />
      <path
        d="M1.18516 10.0937C0.6881 10.0937 0.285156 10.4967 0.285156 10.9937C0.285156 11.4908 0.6881 11.8937 1.18516 11.8937L3.15321 11.8937L3.15321 10.0937L1.18516 10.0937Z"
        fill="white"
      />
      <path
        d="M10.0996 20.8109C10.0996 21.308 10.5026 21.7109 10.9996 21.7109C11.4967 21.7109 11.8996 21.308 11.8996 20.8109L11.8996 18.8429L10.0996 18.8429L10.0996 20.8109Z"
        fill="white"
      />
    </svg>
  );
};

export const IotLightningIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.03044 11.313L11.503 2.31101C11.5977 2.1204 11.7912 2 12.003 2L18.4107 2C18.863 2 19.1281 2.51237 18.8687 2.88527L16.1867 6.74099C15.9273 7.11389 16.1924 7.62626 16.6447 7.62626L18.2689 7.62626C18.7466 7.62626 19.0042 8.19008 18.6933 8.55504L8.2646 20.7994C7.8532 21.2824 7.08627 20.815 7.32104 20.2242L10.2327 12.8989C10.3796 12.5293 10.1091 12.1273 9.7136 12.1273H7.53049C7.1149 12.1273 6.84459 11.6871 7.03044 11.313Z"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const IotUnlockIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M9 9.75V11.625M6.08979 3.76858C6.41632 2.46524 7.5954 1.5 9 1.5C10.6568 1.5 12 2.84314 12 4.5V6.75M5.25 14.25H12.75C13.5784 14.25 14.25 13.5784 14.25 12.75V8.25C14.25 7.42157 13.5784 6.75 12.75 6.75H5.25C4.42157 6.75 3.75 7.42157 3.75 8.25V12.75C3.75 13.5784 4.42157 14.25 5.25 14.25Z"
        stroke="#72E11A"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IotLockIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M9 9.75V11.625M6 6.75V4.5C6 2.84314 7.34314 1.5 9 1.5C10.6568 1.5 12 2.84314 12 4.5V6.75M5.25 14.25H12.75C13.5784 14.25 14.25 13.5784 14.25 12.75V8.25C14.25 7.42157 13.5784 6.75 12.75 6.75H5.25C4.42157 6.75 3.75 7.42157 3.75 8.25V12.75C3.75 13.5784 4.42157 14.25 5.25 14.25Z"
        stroke="#ED0E1B"
        strokeWidth="1.40724"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChangeViewIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M10.0003 10.8307C10.4606 10.8307 10.8337 10.4576 10.8337 9.9974C10.8337 9.53716 10.4606 9.16406 10.0003 9.16406C9.54009 9.16406 9.16699 9.53716 9.16699 9.9974C9.16699 10.4576 9.54009 10.8307 10.0003 10.8307Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M15.1887 9.48375C15.296 9.695 15.3496 9.80058 15.3496 10C15.3496 10.1994 15.296 10.305 15.1887 10.5163C14.6667 11.5444 13.1767 13.75 9.99999 13.75C6.82332 13.75 5.33326 11.5444 4.81122 10.5163C4.704 10.305 4.65039 10.1994 4.65039 10C4.65039 9.80058 4.704 9.695 4.81122 9.48375C5.33326 8.45558 6.82332 6.25 9.99999 6.25C13.1767 6.25 14.6667 8.45558 15.1887 9.48375Z"
        stroke="white"
        strokeWidth="1.6"
      />
      <path
        d="M14.1667 3.33594H14.3333C15.8261 3.33594 16.5725 3.33594 17.0363 3.79969C17.5 4.26343 17.5 5.00982 17.5 6.5026V6.66927M14.1667 16.6693H14.3333C15.8261 16.6693 16.5725 16.6693 17.0363 16.2055C17.5 15.7418 17.5 14.9954 17.5 13.5026V13.3359M5.83333 3.33594H5.66667C4.17388 3.33594 3.42749 3.33594 2.96375 3.79969C2.5 4.26343 2.5 5.00982 2.5 6.5026V6.66927M5.83333 16.6693H5.66667C4.17388 16.6693 3.42749 16.6693 2.96375 16.2055C2.5 15.7418 2.5 14.9954 2.5 13.5026V13.3359"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const IotLockdownIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3164 6.71698C12.3164 7.09003 12.014 7.39245 11.6409 7.39245H5.2321C4.85904 7.39245 4.55662 7.09003 4.55662 6.71698C4.55662 6.34392 4.85904 6.0415 5.2321 6.0415L11.6409 6.0415C12.014 6.0415 12.3164 6.34392 12.3164 6.71698Z"
        fill="#ED0E1B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.80941 2.83363C6.55546 3.03843 6.34595 3.35583 6.25145 3.8828C6.18546 4.25071 5.89434 4.5568 5.52055 4.5568C5.14676 4.5568 4.83742 4.2524 4.88375 3.88149C4.99491 2.99155 5.34083 2.27905 5.95969 1.77997C6.69664 1.18565 7.69538 1 8.76055 1C11.1856 1 12.3173 2.77928 12.3173 4.1968V6.1105C12.6479 6.1773 13.0074 6.29762 13.3388 6.49645C13.9566 6.86718 14.4773 7.51991 14.4773 8.5168V9.93803C14.4773 10.3036 14.181 10.6 13.8154 10.6C13.4551 10.6 13.161 10.3119 13.1536 9.95178L13.1237 8.5168C13.1237 8.07369 12.9245 7.82642 12.6423 7.65715C12.3249 7.46667 11.9143 7.3936 11.6405 7.3936C11.2668 7.3936 10.9638 7.09059 10.9638 6.7168V4.1968C10.9638 3.45432 10.3675 2.3536 8.76055 2.3536C7.80972 2.3536 7.18846 2.52795 6.80941 2.83363Z"
        fill="#ED0E1B"
      />
      <path d="M3 5.27686L15 13.96L3 5.27686Z" fill="#ED0E1B" />
      <path
        d="M3 5.27686L15 13.96"
        stroke="#ED0E1B"
        strokeWidth="1.3536"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.3536 12.5131C4.3536 12.8685 4.48653 13.0254 4.61226 13.1159C4.77249 13.2313 4.9851 13.2763 5.1168 13.2763H11.7653C12.1391 13.2763 12.4421 13.5793 12.4421 13.9531C12.4421 14.3269 12.1391 14.6299 11.7653 14.6299H5.1168C4.7685 14.6299 4.26111 14.531 3.82134 14.2144C3.34707 13.8729 3 13.3097 3 12.5131V8.91313C3 8.53934 3.30301 8.23633 3.6768 8.23633C4.05059 8.23633 4.3536 8.53934 4.3536 8.91313V12.5131Z"
        fill="#ED0E1B"
      />
      <path
        d="M13.1386 13.5131C13.6129 13.1717 14.4922 14.857 14.4922 14.0604V9.91313C14.4922 9.53934 14.1892 9.23633 13.8154 9.23633C13.4416 9.23633 13.1386 9.53934 13.1386 9.91313V13.5131Z"
        fill="#ED0E1B"
      />
    </svg>
  );
};
